// Removing the first 5 characters (#chg-) from the file href leaves just the file path.
export const removeUrlHashPrefix = (href: string) => href.slice(5);
